module.exports = __webpack_public_path__ + "media/country_flags/jm-e08328df.png";